import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {getEmployeeDatas} from "../../../redux/modules/Employee/action";

class Employee extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getEmployeeDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.employee.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const employeeColumn = [
            {
                name: "Employee Name",
                path: "name",
                show: true,
            },
            {
                name: "NIP",
                path: "nip",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"Employee Data"}
                        data={this.props.employee.datas}
                        columns={employeeColumn}
                        action={["update"]}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    employee: state.employee,
});

const mapDispatchToProps = {
    getEmployeeDatas,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(Employee)
);
